import { CellProps } from 'react-table';
import {
    AdminBookingApiModel,
    BookingStatus,
    CampaignManagerBookingApiModel,
    Currency,
    InstagramStoryEvidenceFilePayload,
} from '@round/api';
import { asMoney } from '../../../utils/utits';
import React from 'react';
import { AdminBookingsTableRow } from '../../admin/Bookings/BookingsTable/AdminBookingsTable';
import { CampaignManagerBookingsTableRow } from '../../campaignManager/bookings/BookingsTable/CampaignManagerBookingsTable';

export type BookingsTableData = AdminBookingsTableRow | CampaignManagerBookingsTableRow;
export type BookingsApiModel =
    | AdminBookingApiModel
    | CampaignManagerBookingApiModel
    | InstagramStoryEvidenceFilePayload;
export type BookingTableCellProps<T extends BookingsTableData> = CellProps<T>;
export const NON_EDITABLE_BOOKING_STATUSES: BookingStatus[] = ['offer_sent', 'declined', 'voided'];

export const renderTotalsAsMoney = (totals: Record<number, number>, currencies: Currency[]) => {
    return Object.entries(totals).map(([currency, amount]) => (
        <div key={currency}>
            {asMoney(
                amount,
                currencies.find((c) => c.id === Number(currency))
            )}
        </div>
    ));
};
